export default function obTpd(state = {}, action) {
  switch (action.type) {
    case "GET_OROBONDS_TPD":
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}
